import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IStaticFilter } from '../../../interfaces/record.interfaces';
import {
    expandedAnimation,
    rightPanelAnimation,
} from '../../../animations/height.animation';
import { log } from 'console';

@Component({
    selector: 'app-filter-component',
    templateUrl: './filter-component.html',
    styleUrls: ['./filter-component.scss'],
    animations: [expandedAnimation, rightPanelAnimation],
    standalone: false
})
export class FilterComponent {
    @Input() public staticFilterSelected: number | null = null; //выбранный элемент
    @Input() public filterList: IStaticFilter[] = []; //список фильтров
    @Input() public searchAmine: any; //анимация
    @Output() public filterChanged = new EventEmitter<{
        typeEvent: string;
        data: any;
    }>(); //изменения фильтра
    @Output() public closeFilter = new EventEmitter<void>(); //кнопка закрытия фильтра

    public filterComponentExpanded = false;
    public isFilterVisible = true;
    public selectedCheckbox: number | null = null;
    public loading: boolean = true;
    public constructor() {}

    public ngOnInit(): void {
        this.loading = true;

        // this.getStaticFilterList();
        if (this.staticFilterSelected) {
            this.onLabelClick(this.staticFilterSelected);
        }
        setTimeout(() => {
            this.loading = false;
        }, 500);
    }

    // getStaticFilterList(): void {
    //     lastValueFrom(this.recordService.getStacfilterList())
    //         .then((data: IStaticFilter[]) => {
    //             this.filterList = data;
    //             this.filterChanged.emit({
    //                 typeEvent: 'getStacFilters',
    //                 data: this.filterList,
    //             });
    //         })

    //         .catch((error) => {
    //             this.alertService.error(
    //                 'Не удалось загрузить список услуг по данному фильтру.'
    //             );
    //         });
    // }
    public closeDropdown() {
        this.toggleDropdown();
    }
    public clearFilter() {
        this.staticFilterSelected = null;
        this.filterChanged.emit({ typeEvent: 'clearFilter', data: null });
        this.closeFilter.emit();
        this.isFilterVisible = false;
    }

    public updateFilterList() {
        this.filterChanged.emit({
            typeEvent: 'filterListUpdated',
            data: this.filterList,
        });
    }

    public toggleDropdown() {
        this.closeFilter.emit();
    }

    public searchClick() {
        this.filterChanged.emit({
            typeEvent: 'filterListUpdated',
            data: this.staticFilterSelected,
        });
        this.closeFilter.emit();
    }

    public onLabelClick(keyid: any) {
        this.staticFilterSelected = keyid;
        this.filterChanged.emit({ typeEvent: 'filterSelected', data: keyid });
    }

    public selectFilter(keyid: number): void {
        this.filterComponentExpanded = !this.filterComponentExpanded;
        this.staticFilterSelected = keyid;
        this.selectedCheckbox = keyid;
    }
}
